import { FEATURES, FEATURE_LIFT } from '../data/conjointData';

export interface FeatureCluster {
  name: string;
  consumerLabel: string;
  benefitVerb: string;
  features: string[];
}

export const FEATURE_CLUSTERS: FeatureCluster[] = [
  {
    name: 'Tracking & Insights',
    consumerLabel: 'Know your body like never before',
    benefitVerb: 'track',
    features: ['Smart Biometrics Ring', 'Body Composition Analysis', 'DNA Health Report'],
  },
  {
    name: 'Active Wellness',
    consumerLabel: 'Workouts and recovery that fit your life',
    benefitVerb: 'move',
    features: ['Workout Sessions', 'Recovery Sessions'],
  },
  {
    name: 'Personalization & Guidance',
    consumerLabel: 'A plan that adapts to you',
    benefitVerb: 'adapt',
    features: ['Personalized Wellness Plan', 'Nutrition Tracking'],
  },
];

export function getActiveClusters(enabledFeatures: string[]): FeatureCluster[] {
  return FEATURE_CLUSTERS
    .map(c => ({
      ...c,
      features: c.features.filter(f => enabledFeatures.includes(f)),
    }))
    .filter(c => c.features.length > 0);
}

export function getClusterLift(cluster: FeatureCluster): number {
  return cluster.features.reduce((sum, f) => sum + (FEATURE_LIFT[f] || 0), 0);
}

export function getTopFeaturesInPackage(enabledFeatures: string[], max = 3): { name: string; lift: number }[] {
  return FEATURES
    .filter(f => enabledFeatures.includes(f.name))
    .sort((a, b) => b.lift - a.lift)
    .slice(0, max)
    .map(f => ({ name: f.name, lift: f.lift }));
}

export const FEATURE_BENEFIT_MAP: Record<string, string> = {
  'Smart Biometrics Ring': 'track',
  'Body Composition Analysis': 'measure',
  'DNA Health Report': 'understand',
  'Workout Sessions': 'train',
  'Recovery Sessions': 'recover',
  'Personalized Wellness Plan': 'adapt',
  'Nutrition Tracking': 'fuel',
};
